export const PWA_START_PATH_KEY = "otomanager_pwa_start_path";

export function isStandaloneMode() {
  try {
    return (
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true
    );
  } catch {
    return false;
  }
}
